import { useRef, useState, useEffect, ChangeEvent } from "react";
import { useNavigate } from "react-router-dom";
import TextFields, {
  DropDownTextField,
} from "../TextField/text-field.component";
import { TextareaAutosize as BaseTextareaAutosize } from "@mui/base/TextareaAutosize";
import { styled } from "@mui/system";
import {
  AddNewProductModalWrapper,
  AddNewProductModalContainer,
  AddNewProductModalHeader,
  AddNewProductModalDetails,
  AddNewProductModalHeaderText,
  AddNewProductModalUnderText,
  AddNewProductCloseButton,
  AddNewProductModalBody,
  AddNewProductModalInputContainer,
  AddNewProductModalInputContainer1,
  AddNewProductModalLeftSection,
  AddNewProductModalRightSection,
  AddNewProductModalDropWrap,
  AddNewProductModalInputContainerTwo,
  AddNewProductModalMaxQuan,
  AddNewProductModalImageContainer,
  AddNewProductModalButtonContainer,
  AddNewProductPriceType,
  AddProductCardRadioButton,
  AddNewProductSelect,
  RadioButton,
  AddNewProductLabel,
  AddNewProductButtonContainer,
  AddNewProductButtonContainer1,
  AddNewProductModalImg,
  AddProductImgLabel,
  AddNewProductModalInputContainer2,
  ProductDesLabel,
  AddProductImageLabelCon,
  AddNewProductTextArea,
} from "./AddNewProduct.styles";

import Buttons from "../Button/button.component";
import { colors } from "../../theme/color";
import { useLocation } from "react-router-dom";
import { uploadInput } from "../../../public/assets";
import MinHeightTextarea from "../InputArea/TextArea";
import { useMutation } from "@apollo/client";
import {
  AddPaymentLink,
  EditPaymentLink,
} from "../../graphql/mutations/paymentlink";
import { ToastContainer, toast } from "react-toastify";
import { getData } from "../../utils/localStorage";
import { environment } from "../../env";
import { useSelector } from "react-redux";
import { RootState } from "../../store/rootReducer";
import { uploadFile } from "../../utils/uploadFile";

interface AddNewProductModalProps {
  onClose: () => void;
  isEdit?: string;
  editItemId?: string;
}

const AddNewProductModal: React.FC<AddNewProductModalProps> = ({
  onClose,
  isEdit,
  editItemId,
}) => {
  const [addProduct, { loading }] = useMutation(AddPaymentLink, {
    variables: { service: "payment-link" },
  });
  const [updateProduct, { loading: editLoading }] = useMutation(
    EditPaymentLink,
    {
      variables: { ...environment.paymentLinkService },
    }
  );
  const location = useLocation();
  const navigate = useNavigate();
  const [imageFile, setImageFile] = useState<File | null>(null);
  const [imagePreview, setImagePreview] = useState<string | null>(null);
  const [modalOpen, setModalOpen] = useState(true);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const textAreaRef = useRef<HTMLTextAreaElement>(null);
  const [isHovered, setIsHovered] = useState(false);
  const [oneTimeChecked, setOneTimeChecked] = useState(false);
  const [recurringChecked, setRecurringChecked] = useState(false);
  const [imageUrl, setImageUrl] = useState<string | null | undefined>(null);

  const organizationId = useSelector(
    (state: RootState) => state.user.user.organizationId
  );

  const [data, setData] = useState({
    productName: "",
    productDescription: "",
    price: "",
    maxQuantity: "",
    type: "",
    // organizationId: organizationId,
    paymentType: "",
  });

  const handleImageHover = () => {
    setIsHovered(true);
  };

  const handleImageLeave = () => {
    setIsHovered(false);
  };

  const handleImageChange = async (e: ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    setImageFile(file || null);
    if (file) {
      const previewURL = URL.createObjectURL(file);
      setImagePreview(previewURL);
      const imageUrl = await uploadFile(file);
      setImageUrl(imageUrl);
    } else {
      console.log("No image selected.");
      setImagePreview(null);
    }
  };

  const handleImageUpload = async () => {
    try {
      if (fileInputRef.current) {
        fileInputRef.current.click();
      }
    } catch (error) {
      console.error("Error uploading image:", error);
    }
  };

  const handleFieldChange = (
    key: string,
    event: React.ChangeEvent<HTMLTextAreaElement> | string
  ) => {
    const value = typeof event === "string" ? event : event.target.value;
    setData((prevData) => ({
      ...prevData,
      [key]: value,
    }));
  };

  const handleTextareaChange = (
    event: React.ChangeEvent<HTMLTextAreaElement>
  ) => {
    const { value } = event.target;
    setData((prevData) => ({
      ...prevData,
      productDescription: value,
    }));
  };

  useEffect(() => {
    if (textAreaRef.current) {
      textAreaRef.current.focus();
    }
  }, [data.productDescription]);

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const handleOneTimeClick = () => {
    setOneTimeChecked(true);
    setRecurringChecked(false);
  };

  const handleRecurringClick = () => {
    setOneTimeChecked(false);
    setRecurringChecked(true);
  };

  const numericOptions = Array.from({ length: 20 }, (_, index) => ({
    value: (index + 1).toString(),
    label: (index + 1).toString(),
  }));

  const isFormValid = () => {
    return data.productName !== "" && data.price !== "";
  };

  const type = getData("type");
  // const organizationId = getData("organizationId");
  const paymentType = getData("paymentType");
  // console.log("this is organizationId", organizationId);

  const handleSubmit = async (event: any) => {
    event.preventDefault();
    try {
      const type = getData("type");
      // const organizationId = getData("organizationId");
      const paymentType = getData("paymentType");
      // console.log("this is organizationId", organizationId);

      const response = await addProduct({
        variables: {
          input: {
            name: data.productName,
            description: data.productDescription,
            images: [imageUrl],
            type: type || "productsAndSubscription",
            price: parseFloat(data.price),
            quantity: data.maxQuantity || "1",
            paymentType: paymentType || "oneTime",
          },
        },
      });
      console.log("this is the response ", response);
      if (response.data.addProduct.message === "Product added successfully") {
        toast.success("Product created successfully.");
        setModalOpen(false);
        // window.location.reload();
        // navigate("/dashboard/add-product");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleEdit = async (event: any) => {
    event.preventDefault();
    try {
      const type = getData("type");
      // const organizationId = getData("organizationId");
      const paymentType = getData("paymentType");

      const response = await updateProduct({
        variables: {
          updateProductId: editItemId,
          input: {
            name: data.productName,
            description: data.productDescription,
            images: [imageUrl],
            type: type || "productsAndSubscription",
            price: parseFloat(data.price),
            quantity: data.maxQuantity || "1",
            paymentType:
              paymentType || (oneTimeChecked ? "oneTime" : "recurring"),
          },
        },
      });

      console.log("Edit response: ", response);

      if (
        response.data.updateProduct.message === "Product updated successfully"
      ) {
        toast.success("Product updated successfully");
        setModalOpen(false);
      } else {
        toast.error("Failed to update product");
      }
    } catch (error) {
      console.error("Edit error: ", error);
      toast.error("An error occurred while updating product.");
    }
  };

  return (
    <div>
      <ToastContainer />
      {modalOpen && (
        <AddNewProductModalWrapper>
          <AddNewProductModalContainer>
            <AddNewProductModalHeader>
              <AddNewProductModalDetails>
                <AddNewProductModalHeaderText>
                  {isEdit === "edit" ? "Edit New Product" : "Add new Product"}
                </AddNewProductModalHeaderText>
                <AddNewProductModalUnderText>
                  Fill in the information below to add a product
                </AddNewProductModalUnderText>
              </AddNewProductModalDetails>
              <AddNewProductCloseButton onClick={onClose}>
                x
              </AddNewProductCloseButton>
            </AddNewProductModalHeader>
            <AddNewProductModalBody>
              <AddNewProductModalLeftSection>
                <AddNewProductModalInputContainer>
                  <TextFields
                    type="text"
                    label="Product Name"
                    value={data.productName}
                    placeholder="Skincare, Books etc"
                    width="100%"
                    onChange={(value) =>
                      handleFieldChange("productName", value)
                    }
                  />
                </AddNewProductModalInputContainer>
                <AddNewProductModalInputContainer2>
                  <ProductDesLabel>{`Product Description (optional)`}</ProductDesLabel>
                  <AddNewProductTextArea
                    id="myTextarea"
                    rows={5}
                    cols={42}
                    value={data.productDescription}
                    onChange={(value) =>
                      handleFieldChange("productDescription", value)
                    }
                  ></AddNewProductTextArea>
                </AddNewProductModalInputContainer2>
                <AddNewProductModalInputContainer>
                  <TextFields
                    type="number"
                    width="100%"
                    label="Price"
                    placeholder="$.00"
                    value={data.price}
                    onChange={(value) => handleFieldChange("price", value)}
                  />
                </AddNewProductModalInputContainer>
                <AddNewProductModalInputContainer1>
                  <AddNewProductModalMaxQuan>
                    Maximum Quantity *
                  </AddNewProductModalMaxQuan>
                  <AddNewProductModalDropWrap>
                    <DropDownTextField
                      width="30%"
                      label=""
                      placeholder="1"
                      value={data.maxQuantity}
                      onChange={(value) =>
                        handleFieldChange("maxQuantity", value)
                      }
                      options={numericOptions}
                    />
                  </AddNewProductModalDropWrap>
                </AddNewProductModalInputContainer1>
                <AddNewProductPriceType>
                  <AddNewProductSelect>Select pricing type</AddNewProductSelect>
                  <AddProductCardRadioButton>
                    <RadioButton
                      checked={oneTimeChecked}
                      onClick={handleOneTimeClick}
                    />
                    <AddNewProductLabel>One time</AddNewProductLabel>
                    <RadioButton
                      checked={recurringChecked}
                      onClick={handleRecurringClick}
                    />
                    <AddNewProductLabel>Recurring</AddNewProductLabel>
                  </AddProductCardRadioButton>
                </AddNewProductPriceType>
              </AddNewProductModalLeftSection>
              <AddNewProductModalRightSection>
                <AddNewProductModalInputContainerTwo>
                  <AddProductImageLabelCon>
                    <AddProductImgLabel>
                      Upload Image (Optional)
                    </AddProductImgLabel>
                    <AddNewProductModalImageContainer
                      hoverText="Replace Image"
                      onClick={handleImageUpload}
                      hasImage={!imagePreview}
                      isHovered={isHovered}
                      onMouseEnter={handleImageHover}
                      onMouseLeave={handleImageLeave}
                    >
                      <input
                        type="file"
                        accept="image/*"
                        ref={fileInputRef}
                        style={{ display: "none" }}
                        onChange={handleImageChange}
                      />
                      <AddNewProductModalImg
                        src={imagePreview || "/assets/Input.png"}
                      />
                    </AddNewProductModalImageContainer>
                  </AddProductImageLabelCon>

                  <AddNewProductModalButtonContainer>
                    <AddNewProductButtonContainer1>
                      <Buttons
                        handleClick={onClose}
                        label="Cancel"
                        cursor="pointer"
                        border="10px"
                        width="100%"
                        height="50px"
                        borderLine="1px solid #AFAFAF"
                        color={colors.White}
                        textColor={colors.BLACK}
                        style={{
                          width: "70%",
                          height: "44px",
                          borderRadius: "10px",
                          border: "1px solid #AFAFAF",
                          color: "#AFAFAF",
                          backgroundColor: "white",
                        }}
                      />
                    </AddNewProductButtonContainer1>
                    <AddNewProductButtonContainer>
                      <Buttons
                        handleClick={
                          isEdit === "edit" ? handleEdit : handleSubmit
                        }
                        label={
                          loading
                            ? "Adding..."
                            : editLoading
                              ? "Saving..."
                              : isEdit === "edit"
                                ? "Save"
                                : "Add Product"
                        }
                        cursor="pointer"
                        border="10px"
                        width="100%"
                        height="50px"
                        color={
                          colors.ButtonBackgroundColors.primaryDefaultButton
                        }
                        style={{
                          width: "100%",
                          height: "44px",
                          borderRadius: "10px",
                          color: "white",
                          backgroundColor: "#00A603",
                        }}
                        disabled={loading || editLoading || !isFormValid()}
                      />
                    </AddNewProductButtonContainer>
                  </AddNewProductModalButtonContainer>
                </AddNewProductModalInputContainerTwo>
              </AddNewProductModalRightSection>
            </AddNewProductModalBody>
          </AddNewProductModalContainer>
        </AddNewProductModalWrapper>
      )}
    </div>
  );
};

export default AddNewProductModal;
